import CustomNotificationIcon from './CustomNotificationIcon';

export default CustomNotificationIcon;
